import { fetchRate, TRateResponse } from '../../repositories/cian-chat-bot/v1/rate';
import { IApplicationContext } from '../../types/applicationContext';

const DEGRADATION_TELEMETRY_KEY = 'degradation.chatbotSetRating';

export async function fetchSetRating(
  { httpApi, logger, telemetry }: IApplicationContext,
  rating: number,
  comment?: string,
): Promise<boolean> {
  try {
    const { statusCode, response }: TRateResponse = await fetchRate({
      httpApi,
      parameters: {
        rating,
        comment,
      },
    });

    if (statusCode !== 200) {
      telemetry.increment(DEGRADATION_TELEMETRY_KEY);
      logger.warning('Невалидный ответ от сервера', {
        domain: 'src/shared/services/chatbotFeedback/fetchSetRating/fetchSetRating.ts',
        statusCode,
        message: response.message || 'Неизвестная ошибка',
        errors: JSON.stringify(response?.errors),
      });

      return false;
    }

    return true;
  } catch (error) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.error(error, {
      domain: 'src/shared/services/chatbotFeedback/fetchSetRating/fetchSetRating.ts',
      message: 'Не удалось отправить рейтинг',
    });

    return false;
  }
}
